<h5 class="text-xl font-semibold">Filtros</h5>
<div class="grid grid-cols-12 gap-5">
  @for (item of filtros; track $index) { @if(item.type == 'dropdown') {
  <ng-template
    *ngTemplateOutlet="dropdown; context: { $implicit: item }"
  ></ng-template>
  } @if(item.type == 'input') {
  <ng-template
    *ngTemplateOutlet="input; context: { $implicit: item }"
  ></ng-template>
  } @if(item.type == 'date') {
  <ng-template
    *ngTemplateOutlet="date; context: { $implicit: item }"
  ></ng-template>
  } @if(item.type == 'multiselect') {
  <ng-template
    *ngTemplateOutlet="multiselect; context: { $implicit: item }"
  ></ng-template>
  } }
  <div class="col-span-12" *ngIf="showClearButton">
    <app-button
      alineamiento="der"
      texto="Limpiar filtros"
      colorTexto="white"
      (clickBtn)="clearFilters()"
    />
  </div>
</div>

<ng-template #dropdown let-i>
  <div class="lg:col-span-3 md:col-span-6 sm:col-span-12 col-span-12">
    <app-dropdown
      [etiqueta]="i.label"
      [id]="i.query"
      [(option)]="i.value"
      [placeholder]="i.placeholder"
      [options]="i.options"
      [propiedad]="i.property"
      [(option)]="i.value"
      [filtrar]="true"
      [limpiar]="!i.disabled"
      [setFirstValue]="false"
      (optionChange)="
        changeInput(i.query, $event ? $event[i.searchProperty] : '')
      "
      [readonly]="i.disabled"
    />
  </div>
</ng-template>

<ng-template #input let-i>
  <div class="lg:col-span-3 md:col-span-6 sm:col-span-12 col-span-12">
    <app-input
      [etiqueta]="i.label"
      [(valor)]="i.value"
      [id]="i.query"
      [placeholder]="i.placeholder"
      [(valor)]="i.value"
      (valorChange)="changeInput(i.query, $event)"
      [readonly]="i.disabled"
    />
  </div>
</ng-template>

<ng-template #date let-i>
  <div class="lg:col-span-3 md:col-span-6 sm:col-span-12 col-span-12">
    <app-calendar
      [etiqueta]="i.label"
      [id]="i.query"
      [placeholder]="i.placeholder"
      [(valor)]="i.value"
      [showIcon]="true"
      [showClear]="!i.disabled"
      (valorChange)="changeInput(i.query, $event)"
      [readonly]="i.disabled"
    />
  </div>
</ng-template>

<ng-template #multiselect let-i>
  <div class="lg:col-span-3 md:col-span-6 sm:col-span-12 col-span-12">
    <app-dropdown
      [multiple]="true"
      [etiqueta]="i.label"
      [id]="i.query"
      [placeholder]="i.placeholder"
      [options]="i.options"
      [propiedad]="i.property"
      [(option)]="i.value"
      [setFirstValue]="false"
      [filtrar]="true"
      [limpiar]="!i.disabled"
      (optionChange)="
        changeInput(i.query, $event ? returnMap($event, i.searchProperty) : '')
      "
      [readonly]="i.disabled"
    />
  </div>
</ng-template>
